export default function mod(n, m) {
  return ((n % m) + m) % m;
}


// WEBPACK FOOTER //
// ./src/mod.js